/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function CollapseIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "collapse", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M14.5 10.5L19 6", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M19 10.5H14.5V6", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M6 14.5H10.5V19", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M10.5 14.5L6 19", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(CollapseIcon);
export default ForwardRef;
//# sourceMappingURL=collapseIcon.js.map